/**
 * 将金额转成整形，单位(分)
 * @param {金额} amount
 * @returns {整形金额，单位分}
 */
export function amountToInt(amount) {
  if (amount == null || amount == undefined || amount === "") return null;
  let num = Number(amount);
  if (num === 0) {
    // 等于0
    return num;
  } else {
    // 不等于0
    num = num * 100;
    return parseInt(num.toFixed(0)); // 千分位格式化
  }
}

export function amountRateToInt(amount) {
  if (amount == null || amount == undefined || amount === "") return null;
  let num = Number(amount);
  if (num === 0) {
    // 等于0
    return num;
  } else {
    // 不等于0
    num = num * 100000000;
    return parseInt(num.toFixed(0)); // 千分位格式化
  }
}



// WEBPACK FOOTER //
// ./src/utils/number.js